import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './PdpRespHeroCarouselVimeo.scss';

const PdpRespHeroCarouselVimeoLazy = React.lazy(() =>
    import(
        /* webpackChunkName: "PdpRespHeroCarouselVimeo" */
        './PdpRespHeroCarouselVimeo'
    )
);

export const PdpRespHeroCarouselVimeoLazyLoader = props => {
    const [isLoading, setIsLoading] = useState(true);
    const [lazyLoad, setLazyLoad] = useState(props.isCurrentItem);
    if (props.isCurrentItem && !lazyLoad) {
        setLazyLoad(true);
    }
    return (
        <React.Fragment>
            <div
                className={classnames(styles.loadingContainer, {
                    [styles.loading]: isLoading,
                })}
            >
                <Spinner dark size="small" />
                <span className={styles.loadingText}>
                    <FormattedMessage
                        id="PdpRespHeroCarouselVimeoLoading.loadingVideo"
                        defaultMessage="Video Loading"
                    />
                </span>
            </div>
            {lazyLoad && (
                <React.Suspense fallback="">
                    <PdpRespHeroCarouselVimeoLazy {...props} onLoad={() => setIsLoading(false)} />
                </React.Suspense>
            )}
        </React.Fragment>
    );
};
PdpRespHeroCarouselVimeoLazyLoader.propTypes = {
    isCurrentItem: PropTypes.bool,
};
